var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 381,
    height: 381,
    viewBox: "0 0 381 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(2744 11010)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16753",
    "data-name": "Ellipse 16753",
    cx: 190.5,
    cy: 190.5,
    r: 190.5,
    transform: "translate(-2744 -11010)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_269863",
    "data-name": "Group 269863",
    transform: "translate(-2654.541 -10920.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269862",
    "data-name": "Group 269862",
    transform: "translate(25.26 37.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497488",
    "data-name": "Path 497488",
    d: "M132.3,9H31.26A25.335,25.335,0,0,0,6,34.26V97.411a25.335,25.335,0,0,0,25.26,25.26H132.3a25.335,25.335,0,0,0,25.26-25.26V34.26A25.335,25.335,0,0,0,132.3,9Zm12.63,40.416L81.781,86.044,18.63,49.416V34.26L81.781,70.888,144.931,34.26Z",
    transform: "translate(-6 -9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_497489",
    "data-name": "Path 497489",
    d: "M0,0H202.082V202.082H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.da1393ea31f9d6994a6b9dcb9e9a261d.svg";
export { ForwardRef as ReactComponent };